import type { TeamPlayerFinderRegistration } from '../types'

/**
 * SN-8302 — the registrations one roster's Player Finder settings may offer: the
 * team registrations recruiting for THAT roster. Without a roster, every one
 * (the team-wide Registration tab).
 */
export const registrationsForRoster = (
  registrations: readonly TeamPlayerFinderRegistration[],
  rosterId?: string | null
): readonly TeamPlayerFinderRegistration[] =>
  rosterId
    ? registrations.filter((entry) => entry.roster_id === rosterId)
    : registrations
